import type { AppearanceComponent, AppearanceRow } from '@setplex/tria-api'

export const CONTENT: { [K in AppearanceComponent['contentType']]: K } = {
  VOD: 'VOD',
  MOTN_VOD: 'MOTN_VOD',
  MOTN_TV_SHOW: 'MOTN_TV_SHOW',
  TV_CHANNEL: 'TV_CHANNEL',
  TV_SHOW: 'TV_SHOW',
  LIVE_EVENT: 'LIVE_EVENT',
  MIXED: 'MIXED',
  PARTNER_PRODUCT: 'PARTNER_PRODUCT',
  VOD_BUNDLE: 'VOD_BUNDLE',
  TV_BUNDLE: 'TV_BUNDLE',
  TV_SHOW_BUNDLE: 'TV_SHOW_BUNDLE',
  BANNER_CAROUSEL: 'BANNER_CAROUSEL',
}

// supported content, rendered as row
export const ROWS_CONTENT = {
  [CONTENT.VOD]: CONTENT.VOD,
  [CONTENT.MOTN_VOD]: CONTENT.MOTN_VOD,
  [CONTENT.MOTN_TV_SHOW]: CONTENT.MOTN_TV_SHOW,
  [CONTENT.TV_CHANNEL]: CONTENT.TV_CHANNEL,
  [CONTENT.TV_SHOW]: CONTENT.TV_SHOW,
  [CONTENT.LIVE_EVENT]: CONTENT.LIVE_EVENT,
  [CONTENT.MIXED]: CONTENT.MIXED,
  [CONTENT.PARTNER_PRODUCT]: CONTENT.PARTNER_PRODUCT,
  [CONTENT.VOD_BUNDLE]: CONTENT.VOD_BUNDLE,
  [CONTENT.TV_BUNDLE]: CONTENT.TV_BUNDLE,
  [CONTENT.TV_SHOW_BUNDLE]: CONTENT.TV_SHOW_BUNDLE,
}

// supported content, rendered by banner
export const BANNERS_CONTENT = {
  [CONTENT.BANNER_CAROUSEL]: CONTENT.BANNER_CAROUSEL,
}

export const getIsRow = (
  c: AppearanceComponent | Partial<AppearanceComponent> | undefined
): c is AppearanceRow =>
  Boolean(c && c.contentType && ROWS_CONTENT[c.contentType])
